import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgIf } from '@angular/common';
import { TlkButtonComponent } from '@itero/ui-toolkit-angular/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'rx-intuitive-summary-footer',
	templateUrl: './rx-intuitive-summary-footer.component.html',
	styleUrls: ['./rx-intuitive-summary-footer.component.scss'],
	standalone: true,
	imports: [NgIf, TlkButtonComponent, TranslateModule]
})
export class RxIntuitiveSummaryFooterComponent {
	@Input() isContinueToLabBrokerButtonVisible = false;
	@Input() continueToLabBrokerName: string | null = null;
	@Input() labBrokerSendStepBypassed = false;

	@Output() sendClicked = new EventEmitter<void>();
	@Output() continueToLabBrokerClicked = new EventEmitter<void>();
}
